import { mapState, mapActions, mapMutations } from "vuex";
import i18n from "@/helpers/i18n";
// import { _message } from "@/helpers/_message"
export default {
	components: {},
	computed: {
		...mapState({
			thisinhs: (state) => state.trungtuyen.thisinhs,
		}),
	},
	data() {
		return {
			soCmnd: "",
			length_CMND: 9,
			headers: [
				{
					text: "STT",
					value: "stt",
					class: "text-uppercase",
				},
				{
					text: "Mã hồ sơ",
					value: "maHoSo",
					class: "text-uppercase",
				},
				{
					text: "Mã ngành",
					value: "maNganh",
					class: "text-uppercase",
				},
				{
					text: "Tên ngành",
					value: "tenNganh",
					class: "text-uppercase",
				},
				{
					text: "Tổ hợp",
					value: "toHop",
					class: "text-uppercase",
				},
				{
					text: "Tổng điểm 3 môn",
					value: "tongDiem",
					class: "text-uppercase",
				},
				{
					text: "Điểm xét tuyển",
					value: "diemXetTuyen",
					class: "text-uppercase",
				},
				{
					text: "Kết quả",
					value: "ketQua",
					class: "text-uppercase",
				},
				{ text: "", value: "action", class: "text-uppercase" },
			],
			message: "",
		};
	},
	methods: {
		...mapActions({
			traCuu: "trungtuyen/traCuu",
		}),
		...mapMutations({
			updateThiSinh: "trungtuyen/updateThiSinh",
			loadNewTrungTuyens: "trungtuyen/loadNewTrungTuyens",
		}),
		timKiem() {
			this.traCuu(this.soCmnd).then((response) => {
				if (response.data.length <= 0)
					// _message.messageErrorFind(1)
					this.message = this.$t("message.trungTuyen.notTrungTuyen");
			});

		},

		async nhapHoc(trungTuyen, dotDangKy) {
			await this.updateThiSinh(trungTuyen);
			if (dotDangKy.loaiDot.trim() == "HOCBA") {
				await this.$router.push({
					name: "nhap-hoc-trung-tuyen-hoc-ba",
					params: { id: dotDangKy.dotDangKyId },
				});
			} else if (dotDangKy.loaiDot.trim() == "THPT") {
				await this.$router.push({
					name: "nhap-hoc-trung-tuyen-thpt",
					params: { id: dotDangKy.dotDangKyId },
				});
			}
		},
		showButton(item) {
			let today = new Date();
			let ngayBatDau = new Date(item.admissionStartDate);
			let ngayKetThuc = new Date(item.admissionEndDate);
			[today, ngayBatDau, ngayKetThuc].map((item) =>
				item.setHours(0, 0, 0, 0),
			);
			if (today >= ngayBatDau && today <= ngayKetThuc) return true;
			return false;
		},
		colorText(item) {
			switch (item) {
				case "Đỗ":
					return "text-success";
				case "Chưa xét":
					return "text-warning";
				default:
					return "text-danger";
			}
		}
	},
	watch: {
		// soCmnd(value) {
		// 	if (value.length <= 9) {
		// 		return (this.length_CMND = 9);
		// 	} else {
		// 		return (this.length_CMND = 12);
		// 	}
		// },
	},
	filters: {
		hinhThucXetTuyen: function (value) {
			let loaiDot = value.dotDangKy.loaiDot.trim();
			if (loaiDot === "HOCBA") return i18n.t("models.nhapHoc.hocBa");
			else if (loaiDot === "THPT") return i18n.t("models.nhapHoc.kyThi");
			else if (loaiDot === "THI") return i18n.t("models.nhapHoc.thi");
			else return i18n.t("models.nhapHoc.tuyenThang");
		},
		formatDate: function (date) {
			let d = new Date(date),
				month = "" + (d.getMonth() + 1),
				day = "" + d.getDate(),
				year = d.getFullYear();

			if (month.length < 2) month = "0" + month;
			if (day.length < 2) day = "0" + day;

			return [day, month, year].join("/");
		},
	},
	destroyed() {
		this.loadNewTrungTuyens();
	},
};
